import React from "react";

type DataGridFooterProps = React.HTMLAttributes<HTMLDivElement>;

export default function DataGridFooter({ ...props }: DataGridFooterProps) {
    return (
        <div {...props} id='skipTable' className='parent-sticky-footer flex border-t-[1px] bg-white/10 backdrop-blur-[10px] rounded-b-[0.4rem] p-2 items-center gap-4'>
            {props.children}
        </div>
    );
}